import { useSelector } from 'react-redux';

import { selectors as helpCenterSelectors } from '../../../../redux/help-center-page';

const useSelectedCategory = () =>
  useSelector(helpCenterSelectors.selectSelectedCategory);

const useSelectedArticle = () =>
  useSelector(helpCenterSelectors.selectSelectedArticle);

const hooks = { useSelectedCategory, useSelectedArticle };

export default hooks;
